import classNames from 'classnames'

import { type TProgramActualMode } from '@/app/types/dmsTypes'

import style from './Attached.module.scss'

interface IProps {
    programActualMode: TProgramActualMode
}

export const Attached = (props: IProps) => {
    const { programActualMode } = props

    const MAPPER: Record<TProgramActualMode, string> = {
        Actual: 'Прикреплена',
        UnActual: 'Не прикреплена',
        LaterActual: 'Запланирована'
    }

    return (
        <div className={style.container}>
            <div
                className={classNames(
                    style.notifyWrapper,
                    programActualMode === 'Actual' && style.notifyWrapperAttached,
                    programActualMode === 'UnActual' && style.notifyWrapperNotAttached,
                    programActualMode === 'LaterActual' && style.notifyWrapperLaterAttached
                )}
            >
                <span>{MAPPER[programActualMode]}</span>
            </div>
        </div>
    )
}
